export const IMPRESSION_CONTENT = {
  groupType: 'offers',
  groupId: 'offers_list_home',
  groupPosition: 0
}
